import { render, staticRenderFns } from "./sonet-videopicstext-swiper.vue?vue&type=template&id=74fbd9f4&scoped=true&"
import script from "./sonet-videopicstext-swiper.vue?vue&type=script&lang=js&"
export * from "./sonet-videopicstext-swiper.vue?vue&type=script&lang=js&"
import style0 from "./sonet-videopicstext-swiper.vue?vue&type=style&index=0&id=74fbd9f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fbd9f4",
  null
  
)

export default component.exports